// Badge theme — no local variant overrides.
// All colour handling is fully delegated to Tag's theme via the `color` prop.

const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'subtle',
  color: 'grey',
  fontWeight: 'medium',
}

const variants = {}

export default {
  baseStyle,
  defaultProps,
  variants,
}
